import { ActionCreatorWithoutPayload, ActionCreatorWithPayload, combineReducers, configureStore, MiddlewareAPI, PreloadedState } from '@reduxjs/toolkit';
import sessionReducer from './session/slices';

import { socketMiddleware } from './socket/middlewares';
import { actionReducer } from './action';
import meetingReducer from './meeting/slices';
import { requestMiddleware } from './request/middlewares';
import roomReducer from './room/slices';
// import surveyReducer from './survey/slices';

export type StoreAction = ActionCreatorWithPayload<any, string> | ActionCreatorWithoutPayload<string>;

const middlewares = [socketMiddleware, requestMiddleware];

const rootReducer = combineReducers({
  session: sessionReducer,
  meeting: meetingReducer,
  room: roomReducer,
  // survey: surveyReducer,
  action: actionReducer
});

export const setupStore = (preloadedState?: PreloadedState<RootState>) => (
  configureStore({
    reducer: rootReducer,
    preloadedState,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({serializableCheck: false}).concat(middlewares),
  })
);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = AppStore['dispatch'];

export type AppMiddlewareApi = MiddlewareAPI<AppDispatch, RootState>;

export default setupStore;
